<template>
  <!-- 剧集抽屉 -->
  <a-drawer
    :title="name"
    width="700"
    :closable="false"
    :visible="visible"
    @close="onClose"
    :footer-style="{ textAlign: 'right' }"
  >
    <a-form
      ref="RefForm"
      :model="formState"
      :label-col="{ span: 4 }"
      :wrapper-col="{ span: 16 }"
    >
      <!-- 语种剧名 -->
      <a-form-item
        label="语种剧名"
        name="lang_drama_name"
        :rules="[{ required: true }]"
      >
        <a-input v-model:value="formState.lang_drama_name" placeholder="请输入" />
      </a-form-item>
      <!-- 封面 -->
      <a-form-item
        label="封面"
        name="cover"
        :rules="[{ required: true }]"
      >
        <Upload
          accept=".png,.jpg,.gif"
          uploadSource="BaseInfo"
          :fileNumber="1"
          :beforeUploadPro="beforeUploadPro"
          :fileList="formState.cover"
          :uploadBucket="$pub.BUCKET_PUB()"
        />
        <div class="form-upload-hint">支持.png .jpg .gif</div>
        <div class="form-upload-list" v-if="formState.cover.length">
          <ImageView
            class="form-upload-item"
            v-for="(item, index) in formState.cover"
            :key="index"
            :url="$pub.CDN_URL(item.url)"
            :fileJson="item"
            @delete="touchDeleteCover('cover', index)"
          >
          </ImageView>
        </div>
      </a-form-item>
      <!-- 字幕 -->
      <!-- <a-form-item
        label="字幕"
        name="videoHighlight"
        :rules="[{ required: true, validator: validator }]"
      >
        <a-form-item-rest>
          <Upload
            accept=".srt"
            uploadSource="video_highlight"
            :showUploadList="true"
            :fileNumber="1"
            :fileList="formState.videoHighlight"
            :uploadBucket="$pub.BUCKET_PUB()"
          />
        </a-form-item-rest>
        <div class="form-upload-hint">仅支持 .srt 字幕文件</div>
      </a-form-item> -->
      <!-- 权重 -->
      <a-form-item
        label="权重"
        name="weight"
        :rules="[{ required: true, validator: validator }]"
      >
        <a-input v-model:value="formState.weight" placeholder="0 ~ 10000" />
      </a-form-item>
      <!-- 剧情简介 -->
      <a-form-item
        label="剧情简介"
      >
        <a-textarea
          v-model:value="formState.description"
          placeholder="请输入"
          :maxLength="1000"
          :rows="4"
        />
      </a-form-item>
      <!-- 其他付费模式 -->
      <a-form-item
        label="其他付费模式"
        name="pay_type"
      >
        <a-select v-model:value="formState.pay_type" mode="multiple" placeholder="请选择">
          <a-select-option v-for="item in OtherPayModes" :key="item.value" :value="item.value">
            {{ item.text }}
          </a-select-option>
        </a-select>
      </a-form-item>
      <!-- 解锁全集价格 -->
      <a-form-item
        v-if="formState.pay_type.includes(1)"
        label="解锁全集价格"
        name="goods_id"
        :rules="[{ required: true, validator: validatorMoney }]"
      >
        <a-select
          class="form-input"
          v-model:value="formState.goods_id"
          placeholder="请选择"
          :getPopupContainer="(triggerNode) => triggerNode.parentNode"
        >
          <template #suffixIcon>
            <span class="select-suffix">元</span>
          </template>
          <a-select-option v-for="(item,index) in goodList" :key="index" :value="item.id">{{ moneyConversion(item.money) }}</a-select-option>
        </a-select>
      </a-form-item>
      <!-- 广告解锁集数 -->
      <a-form-item
        v-if="formState.pay_type.includes(2)"
        label="广告解锁集数"
        name="ad_num_episode"
        :rules="[{ required: true, validator: validatorInteger }]"
      >
        <a-input class="form-input" v-model:value="formState.ad_num_episode" placeholder="请输入" />
      </a-form-item>
      <!-- 默认付费面板 -->
      <a-form-item
        label="默认付费面板"
        name="charge_id"
        :rules="[{ required: true }]"
      >
        <a-select
          class="form-input"
          show-search
          v-model:value="formState.charge_id"
          placeholder="请选择"
          :getPopupContainer="(triggerNode) => triggerNode.parentNode"
          :filter-option="filterOption"
          @mouseleave="mouseleave"
        >
          <a-select-option
            v-for="item in defaultList"
            :key="`${item.id}-${item.name}`"
            :value="item.id"
            @mouseenter="mouseenter(item.id)"
          >
            {{ item.name }}
          </a-select-option>
        </a-select>
        <a style="margin-left: 10px;" @click="touchPreview(formState.charge_id)">预览</a>
      </a-form-item>
      <!-- 每集收费 -->
      <a-form-item
        label="每集收费"
        name="fee"
        :rules="[{ required: true, validator: validatorInteger }]"
      >
        <a-input class="form-input" v-model:value="formState.fee" placeholder="请输入" suffix="金币" />
      </a-form-item>
      <!-- 基础播放量 -->
      <a-form-item
        label="基础播放量"
        name="play_count"
        :rules="[{ required: true, validator: validatorInteger }]"
      >
        <a-input
          class="form-input"
          placeholder="请输入"
          v-model:value="formState.play_count"
        />
        <a class="a-link" @click="setBasicPlayNum(1000)">千级</a>
        <a class="a-link" @click="setBasicPlayNum(10000)">万级</a>
        <a class="a-link" @click="setBasicPlayNum(100000)">十万级</a>
        <a class="a-link" @click="setBasicPlayNum(1000000)">百万级</a>
      </a-form-item>
      <!-- 基础点赞系数 -->
      <a-form-item
        label="基础点赞系数"
        name="rate_like"
        :rules="[{ required: true, validator: validatorBaseFloat }]"
      >
        <a-input
          class="form-input"
          v-model:value="formState.rate_like"
          placeholder="请输入 0.01-0.99"
        />
      </a-form-item>
      <!-- 基础收藏系数 -->
      <a-form-item
        label="基础收藏系数"
        name="rate_favorite"
        :rules="[{ required: true, validator: validatorBaseFloat }]"
      >
        <a-input
          class="form-input"
          v-model:value="formState.rate_favorite"
          placeholder="请输入 0.01-0.99"
        />
      </a-form-item>
      <!-- 基础分享系数 -->
      <a-form-item
        label="基础分享系数"
        name="rate_share"
        :rules="[{ required: true, validator: validatorBaseFloat }]"
      >
        <a-input
          class="form-input"
          v-model:value="formState.rate_share"
          placeholder="请输入 0.01-0.99"
        />
      </a-form-item>
      <!-- 排序权重 -->
      <a-form-item
        label="排序权重"
        name="weight"
        :rules="[{ required: true, validator: validatorInteger }]"
      >
        <a-input
          class="form-input"
          placeholder="请输入"
          v-model:value="formState.weight"
        />
      </a-form-item>
      <!-- 达人推广 -->
      <a-form-item
        label="达人推广"
        name="talent_promotion"
      >
        <a-switch v-model:checked="formState.talent_promotion" />
      </a-form-item>
      <!-- 达人素材 -->
      <a-form-item
        v-if="formState.talent_promotion"
        label="达人素材"
        name="talent_material"
        :rules="[{ required: true }]"
      >
        <a-select
          v-model:value="formState.talent_material"
          placeholder="请选择"
        >
          <a-select-option
            v-for="mask in TalentMaterials"
            :key="mask.value"
            :value="mask.value"
          >
            {{ mask.text }}
          </a-select-option>
        </a-select>
      </a-form-item>
    </a-form>
    <!-- 尾部 -->
    <template #footer>
      <a-button style="margin-right: 8px" @click="onClose">取消</a-button>
      <a-button type="primary" @click="touchSubmit">{{ isEdit ? '完成' : '入库' }}</a-button>
    </template>
    <!-- 加载 -->
    <Loading :loading="isLoading"></Loading>
    <!-- 支付模版预览 -->
    <PayPreviewModal ref="RefPayPreviewModal"></PayPreviewModal>
    <!-- 支付模版预览 -->
    <PayPreviewView ref="RefPayPreviewView"></PayPreviewView>
  </a-drawer>
</template>

<script setup>
import { ref, reactive, nextTick } from 'vue'
import { message } from 'ant-design-vue'
import Loading from '@/components/Loading'
import Upload from '@/components/Upload'
import ImageView from '@/components/ImageView'
import PayPreviewModal from '@/views/admin/supporting/components-rechargepanel/PreviewModal'
import PayPreviewView from '@/views/admin/supporting/components-rechargepanel/PreviewView'
import Pub from '@/utils/public'
import { storageDrama, dramaDetail, dramaEdit, chargeAll } from '@/api/appfront'
import { goodAll } from '@/api/admin'
import { OtherPayModes, TalentMaterials } from '@/utils/constantList'

const emit = defineEmits('success')
// Form实例
const RefForm = ref(null)
// 支付模版预览
const RefPayPreviewModal = ref(null)
const RefPayPreviewView = ref(null)
// 抽屉展示状态
let visible = ref(false)
// 加载
let isLoading = ref(false)
// 片库ID、name
let id = ref(undefined)
let name = ref(undefined)
// 是否编辑
let isEdit = ref(false)
// 默认付费面板
let defaultList = ref([])
// 商品列表
let goodList = ref([])
// 剧集信息
let formState = reactive({
  // 语种剧名
  lang_drama_name: undefined,
  // 封面
  cover: [],
  // 权重
  weight: undefined,
  // 剧情简介
  description: undefined,
  // 其他付费模式
  pay_type: [],
  // 解锁全集价格
  goods_id: undefined,
  // 广告解锁集数
  ad_num_episode: undefined,
  // 默认付费面板
  charge_id: undefined,
  // 每集收费
  fee: undefined,
  // 基础播放量
  play_count: undefined,
  // 基础点赞系数
  rate_like: undefined,
  // 基础收藏系数
  rate_favorite: undefined,
  // 基础分享系数
  rate_share: undefined,
  // 排序权重
  weight: undefined,
  // 达人推广
  talent_promotion: false,
  // 达人素材
  talent_material: undefined
})

// 打开抽屉
function showDrawer (record, edit = false) {
  visible.value = true
  id.value = record.id
  name.value = record.name
  isEdit.value = edit
  // 获取详情
  getDramaDetail()
  // 获取选择项
  getSelectList()
}


// 获取选择项
function getSelectList () {
  // 默认模版
  chargeAll().then(res => {
    const { code, data } = res
    if (code === 0) {
      defaultList.value = data
    }
  })
  goodAll().then(res => {
    const { code, data } = res
    if (code === 0) {
      goodList.value = data
    }
  })
}

// 获取剧集详情
function getDramaDetail () {
  dramaDetail({ id: id.value }).then(res => {
    const { code, data } = res
    if (code === 0) {
      let info = data.info
      formState.lang_drama_name = info.lang_drama_name
      formState.cover = info.cover_hs ? [{ url: info.cover_hs }] : []
      formState.weight = info.weight
      formState.description = info.description
      formState.pay_type = info.pay_type || []
      formState.goods_id = info.goods_id
      formState.ad_num_episode = info.ad_num_episode
      formState.charge_id = info.charge_id
      formState.fee = info.fee
      formState.play_count = info.play_count
      formState.rate_like = info.rate_like
      formState.rate_favorite = info.rate_favorite
      formState.rate_share = info.rate_share
      formState.weight = info.weight
      formState.talent_promotion = info.talent_promotion ? true : false
      formState.talent_material = info.talent_material
    }
  })
}

// 金额转换
function moneyConversion (money) {
  return Pub.KEEP_NUMBER_DECIMAL(money/100.0, 2, false, false)
}

// 关闭抽屉
function onClose () {
  if (!isLoading.value) {
    RefForm.value.resetFields()
    visible.value = false
    formState.lang_drama_name = undefined
    formState.cover = []
    formState.weight = undefined
    formState.description = undefined
    formState.pay_type = []
    formState.goods_id = undefined
    formState.ad_num_episode = undefined
    formState.charge_id = undefined
    formState.fee = undefined
    formState.play_count = undefined
    formState.rate_like = undefined
    formState.rate_favorite = undefined
    formState.rate_share = undefined
    formState.weight = undefined
    formState.talent_promotion = false
    formState.talent_material = undefined
  }
}

// 模糊匹配
function filterOption (input, option) {
  return `${option.key}`.toLowerCase().includes(`${input || ''}`.toLowerCase())
}

// 准备上传（图片）
function beforeUploadPro (file) {
  if (!file.type.includes('image')) {
    message.error('请上传图片类型的文件')
    return false
  }
  return true
}

// 表单校验
function validator (rule, value) {
  // 权重
  if (rule.field === 'weight') {
    if (!value) {
      return Promise.reject('请输入权重')
    } else if (!Pub.REG_IS_INTEGER(value) || value > 10000 || value < 0) {
      return Promise.reject('必须为 0-10000 的正整数')
    }
    return Promise.resolve()
  }
}

// 表单校验（金额）
function validatorMoney (rule, value) {
  if (!value) {
    return Promise.reject('请输入')
  } else if (!Pub.REG_IS_INTEGER_OR_FLOAT(value)) {
    return Promise.reject('必须为正数，且最多保留两位小数')
  }
  return Promise.resolve()
}

// 表单校验（整数）
function validatorInteger (rule, value) {
  if (!value) {
    return Promise.reject('请输入')
  } else if (!Pub.REG_IS_INTEGER(value)) {
    return Promise.reject('必须为正整数')
  }
  return Promise.resolve()
}

// 表单校验（基础系数）
function validatorBaseFloat (rule, value) {
  if (!value) {
    return Promise.reject('请输入')
  } else if (!Pub.REG_IS_INTEGER_OR_FLOAT(value) || value < 0.01 || value > 0.99) {
    return Promise.reject('必须为 0.01-0.99 的浮点数')
  }
  return Promise.resolve()
}

// 移除封面
function touchDeleteCover (coverKey, index) {
  formState[coverKey].splice(index, 1)
}

// 提交
function touchSubmit () {
  RefForm.value.validate().then((() => {
    isLoading.value = true
    // 准备数据
    const params = {
      id: id.value,
      lang_drama_name: formState.lang_drama_name,
      cover: formState.cover[0].url,
      weight: formState.weight,
      description: formState.description,
      pay_type: formState.pay_type,
      goods_id: formState.goods_id,
      ad_num_episode: formState.ad_num_episode,
      charge_id: formState.charge_id,
      fee: formState.fee,
      play_count: formState.play_count,
      rate_like: formState.rate_like,
      rate_favorite: formState.rate_favorite,
      rate_share: formState.rate_share,
      weight: formState.weight,
      talent_promotion: formState.talent_promotion ? 1 : 0,
      talent_material: formState.talent_material
    }
    if (isEdit.value) {
      dramaEdit(params).then(res => {
        isLoading.value = false
        const { code, msg, data } = res
        if (code === 0) {
          message.success('操作成功')
          onClose()
          emit('success')
        } else {
          message.error(res.message || msg)
        }
      })
    } else {
      storageDrama(params).then(res => {
        isLoading.value = false
        const { code, msg, data } = res
        if (code === 0) {
          message.success('操作成功')
          onClose()
          emit('success')
        } else {
          message.error(res.message || msg)
        }
      })
    }
  }))
}

// 预览充值模版
function touchPreview(charge_id) {
  RefPayPreviewModal.value.showModal(charge_id)
}

// 进入元素
function mouseenter (id) {
  RefPayPreviewView.value.show(id)
}

// 离开元素
function mouseleave () {
  RefPayPreviewView.value.hide()
}

// 设置基础播放量随机数
function setBasicPlayNum (level) {
  formState.play_count = Pub.RANDOM(level)
}

// 暴露出去
defineExpose({
  showDrawer
})

</script>

<style lang="less" scoped>
.form-input {
  width: 50%;
}
.a-link {
  margin-left: 8px;
}
.form-item-clear {
  margin-bottom: 0;
}
.form-upload-hint {
  padding-top: 6px;
  color: #8D8D8D;
}
.form-upload-list {
  display: flex;
  flex-wrap: wrap;
  margin-left: -10px;
}
// .form-upload-item {
//   margin-top: 10px;
//   margin-left: 10px;
//   position: relative;
//   width: 118px;
//   height: 148px;
//   border-radius: 4px;
//   overflow: hidden;
//   img {
//     display: inline-block;
//     width: 100%;
//     height: 100%;
//     object-fit: cover;
//   }
//   &.horizontal {
//     width: 148px;
//     height: 118px;
//   }
// }
.image-view.form-upload-item {
  margin-top: 10px;
  margin-left: 10px;
  width: 118px;
  height: 148px;
  &.horizontal {
    width: 148px;
    height: 118px;
  }
}
.checkbox-form {
  position: absolute;
  right: 8px;
  bottom: 18px;
  width: 14px;
  height: 14px;
  margin-bottom: 0;
}
.date-range {
  color: #8D8D8D;
  padding-left: 100px;
  margin-top: -15px;
}
.select-suffix {
  color: #fff;
  font-size: 14px;
  white-space: nowrap;
  padding-right: 20px;
}
</style>